import { useContext, useEffect, type FC } from "react";
import {
    defaultLayoutContext,
    LayoutActionsContext,
    LayoutPermissionMode,
    type ILayoutItemContext,
} from "src/contexts/layouts/LayoutContext";
import type { Permission } from "src/api/Tmd.dtos";

interface ISetPagePermissionProps {
    context: ILayoutItemContext;
    permission: Permission;
    permissionMode: LayoutPermissionMode;
}

const SetPagePermission: FC<ISetPagePermissionProps> = ({
    context,
    permission,
    permissionMode,
}) => {
    const layoutContext = useContext(LayoutActionsContext);

    useEffect(() => {
        layoutContext.setPermission(permission);
        layoutContext.setPermissionMode(permissionMode);
        layoutContext.setContext(context);

        return () => {
            layoutContext.setPermission(defaultLayoutContext.permission);
            layoutContext.setPermissionMode(defaultLayoutContext.permissionMode);
            layoutContext.setContext(defaultLayoutContext.context);
        };
    }, [
        permission,
        permissionMode,
        context.trialId,
        context.institutionId,
        context.groupId,
        context.personnelId,
        layoutContext,
    ]);

    return null;
};

export default SetPagePermission;
